import images from "./images";

const testimonials = [
  {
    id: 1,
    image: images.testimonial1,
    name: "Richard Turner",
    title: "Manager",
    content: "Aquadrop provides exceptional water delivery service. Timely, fresh, and always with great care. I’ve trusted them for months now and my team stays hydrated effortlessly. Highly recommended service!",
  },
  {
    id: 2,
    image: images.testimonial2,
    name: "Olivia Grace",
    title: "Housewife",
    content: "We love how easy it is to place orders and receive clean water at home. The bottles are sealed and safe, giving my family peace of mind every single day. Excellent service!",
  },
  {
    id: 3,
    image: images.testimonial3,
    name: "Christopher Lewis",
    title: "Volunteer",
    content: "Fast delivery and courteous staff. We rely on Aquadrop during our community events and they’ve never let us down. Clean water, hassle-free orders, and outstanding customer service always.",
  },
  {
    id: 4,
    image: images.testimonial4,
    name: "Sophia Martinez",
    title: "Event Organizer",
    content: "During our last big event, Aquadrop handled all the water delivery without a problem. The entire process was smooth, from ordering to on-time delivery. Truly dependable for large gatherings.",
  },
];


export default testimonials;